import React, { useState, useEffect, useReducer } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Input,
  Tooltip,
  Form,
  Modal,
  Select,
  Space,
  InputNumber,
} from "antd";
import { EditOutlined, PlusOutlined, DeleteOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import { TableCustom } from "../../../components/table";
import { reducerRegister } from "../../../helpers/reducers";
import {
  createGroupApi,
  deleteGroupApi,
  getAllGroupsApi,
  getGroupByIdApi,
  updateGroupApi,
} from "../../../api/formsColaboradoresGroups";
import { getFormByIdApi } from "../../../api/formsColaboradoresForms";
const { Text } = Typography;

const options_status = [
  { value: 0, label: "Inativo" },
  { value: 1, label: "Ativo" },
];

const rules = {
  descricao: [{ required: true, message: "Digite a descrição!" }],
  ordem: [{ required: true, message: "Digite a ordem!" }],
  status: [{ required: true, message: "Selecione o status!" }],
};

export const FormulariosColaboradoresCadGrupos = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, dispatch] = useReducer(reducerRegister, []);
  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();
  const [idAlt, setIdAlt] = useState(0);
  const [formulario, setFormulario] = useState(null);
  const { id_cad_formularios } = useParams();

  useEffect(() => {
    if (id_cad_formularios) {
      getAllGroups(id_cad_formularios);
      getFormById(id_cad_formularios);
    }
  }, [id_cad_formularios]);

  const getFormById = async (id) => {
    setLoading(true);
    try {
      const { statusCode, response } = await getFormByIdApi(id);
      if (statusCode === 200) {
        if (!response.data) {
          navigate("/formularios-colaboradores/formularios");
        }
        setFormulario(response.data);
      } else {
        navigate("/formularios-colaboradores/formularios");
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
      navigate("/formularios-colaboradores/formularios");
    } finally {
      setLoading(false);
    }
  };

  const getAllGroups = async (form_id) => {
    setLoading(true);
    try {
      const { statusCode, response } = await getAllGroupsApi(form_id);
      if (statusCode === 200) {
        dispatch({ type: "LOAD", payload: response?.data });
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const createGroup = async (data) => {
    setLoading(true);
    try {
      const { statusCode, response } = await createGroupApi(data);
      if (statusCode === 200) {
        message.success("Registro cadastrado com sucesso!");
        setShowModal(false);
        resetForm();
        if (response?.data) dispatch({ type: "ADD", payload: response?.data });
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const updateGroup = async (data) => {
    setLoading(true);
    try {
      const { statusCode, response } = await updateGroupApi(data);
      if (statusCode === 200) {
        message.success("Registro alterado com sucesso!");
        setShowModal(false);
        resetForm();
        if (response?.data) dispatch({ type: "UPDATE", payload: response?.data });
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const getGroupById = async (id) => {
    setLoading(true);
    try {
      const { statusCode, response } = await getGroupByIdApi(id);
      if (statusCode === 200) {
        setShowModal(true);
        form.setFieldsValue({
          descricao: response?.data?.descricao,
          ordem: response?.data?.ordem,
          status: response?.data?.status,
        });
        setIdAlt(response.data.id);
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const deleteGroup = async (id) => {
    setLoading(true);
    try {
      const { statusCode, response } = await deleteGroupApi(id);
      if (statusCode === 200) {
        message.success("Registro deletado com sucesso!");
        dispatch({ type: "DELETE", payload: { id: id } });
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  const columns = [
    {
      title: "Descrição",
      dataIndex: "descricao",
    },
    {
      title: "Ordem",
      dataIndex: "ordem",
    },
    {
      dataIndex: "status",
      title: "Status",
      render: (_, e) => (e.status === 1 ? "Ativo" : "Inativo"),
      renderText: (e) => (e.status === 1 ? "Ativo" : "Inativo"),
    },
    {
      dataIndex: "acoes",
      title: "Ações",
      width: 150,
      sorter: false,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Questões">
            <Button
              loading={loading}
              onClick={() =>
                navigate(`/formularios-colaboradores/formularios/grupos/${id_cad_formularios}/questoes/${e.id}`)
              }
              icon={<UnorderedListOutlined />}
            />
          </Tooltip>
          <Button loading={loading} onClick={() => getGroupById(e.id)} icon={<EditOutlined />} />
          <Button
            danger
            loading={loading}
            icon={<DeleteOutlined />}
            onClick={() => {
              modal.confirm({
                title: "Deseja deletar este registro?",
                okText: "Sim",
                cancelText: "Cancelar",
                onOk() {
                  deleteGroup(e.id);
                },
              });
            }}
          />
        </Space.Compact>
      ),
    },
  ];

  const onSubmit = (formData) => {
    formData.id_cad_formularios = id_cad_formularios;
    if (idAlt > 0) {
      formData.id = idAlt;
      updateGroup(formData);
    } else {
      createGroup(formData);
    }
  };

  const modalFormulario = (
    <Modal
      title={
        <Text style={{ fontSize: 20 }}>
          <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Formulário
        </Text>
      }
      open={showModal}
      onOk={() => form.submit()}
      okText="Salvar"
      width={1200}
      okButtonProps={{ size: "large", loading: loading }}
      cancelButtonProps={{ size: "large", loading: loading }}
      onCancel={() => {
        setShowModal(false);
        resetForm();
      }}>
      <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="descricao" label="Descrição" rules={rules.descricao}>
              <Input size="large" disabled={loading} placeholder="Informe a descrição" />
            </Form.Item>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="ordem" label="Ordem" rules={rules.ordem}>
              <InputNumber
                className="full-width"
                size="large"
                controls={false}
                disabled={loading}
                placeholder="Informe a ordem"
                min={1}
                max={1000}
                step={1}
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="status" label="Status" rules={rules.status}>
              <Select
                size="large"
                placeholder="Selecione o status"
                disabled={loading}
                style={{ width: "100%" }}
                options={options_status}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage
              title="Formulários Colaboradores"
              onClickBack={() => navigate("/formularios-colaboradores/formularios")}
            />
            <HeaderTitle
              title={["Formulários", "Grupos"]}
              subtitle={`Formulário - ${formulario?.descricao ?? ""}`}
              icon={<UnorderedListOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <TableCustom
                extraHeaderComponents={
                  <Tooltip title="Adicionar Registro">
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => {
                        setShowModal(true);
                        resetForm();
                      }}
                      loading={loading}>
                      Novo
                    </Button>
                  </Tooltip>
                }
                loading={loading}
                columns={columns}
                dataSource={dados}
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
